class VoiceSwiper {
  constructor(el, opt){
    this.el = el;
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {

    const voiceSwiper = '.js-voice-swiper';

    $(voiceSwiper).each(function(){
      const thisData = $(this).data('swiper');
      let detailSwiper = new Swiper('[data-swiper="'+thisData+'"] .swiper-container', {
        loop: true,
        allowTouchMove: true,
        spaceBetween: 30,
        navigation: {
          nextEl: '[data-swiper="'+thisData+'"] .swiper-next',
          prevEl: '[data-swiper="'+thisData+'"] .swiper-prev',
        },
        pagination: {
          el: '[data-swiper="'+thisData+'"] .swiper-pagination',
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 70,
          }
        }
      });
    })

  }

}
